// extracted by mini-css-extract-plugin
export default {"list":"IncomeBreakdown_list__Oh4sv","row":"IncomeBreakdown_row__-+SrM","label":"IncomeBreakdown_label__q0-qr","value":"IncomeBreakdown_value__RcTNl"};